import { ServiceSubTypesEnum, ServiceTypesEnum } from "@propertelligent/client-api";

type EnumOptions = {
  humanReadable?: boolean;
  fallback?: string;
};

function baseGetEnumNames<T extends Record<number, string>>(
  enumObj: T,
  ids?: number[],
  options?: EnumOptions
): string {
  if (!ids?.length) return options?.fallback ?? '';

  return ids
    .map(id => enumObj[id])
    .filter(Boolean)
    .map(name =>
      options?.humanReadable
        ? name.replace(/([A-Z])/g, ' $1').trim()
        : name
    )
    .join(' | ');
}

/* 🔥 Ready-to-use helpers */
export const getServiceTypeNames = (
  ids?: number[],
  options?: EnumOptions
) => baseGetEnumNames(ServiceTypesEnum, ids, options);

export const getServiceSubTypeNames = (
  ids?: number[],
  options?: EnumOptions
) => baseGetEnumNames(ServiceSubTypesEnum, ids, options);

// Builds {Id, Name} dropdown options from a numeric enum's own reverse-mapping,
// so the label always matches the enum member name instead of being duplicated
// as a separate hardcoded string.
export function getEnumOptions<T extends Record<number, string>>(
  enumObj: T,
  ids: number[]
): { Id: number; Name: string }[] {
  return ids
    .filter((id): id is number => id != null && enumObj[id] != null)
    .map((id) => ({ Id: id, Name: enumObj[id] }));
}
